import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { SearchType, TextKey } from '@mews-commander/enums';
import { ApplicationState, WithCompanyId } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { getCompanyChainIdIfNoEnterpriseId } from '@mews-commander/legacy-entities/src/selectors';
import { SearchFormField } from '../../../../components/form';

const fieldMotherCompanyId = 'motherCompanyId';
interface OwnProps extends WithCompanyId {
    form: string;
}

interface StateProps {
    preselectedResultId: string;
    chainId: string | null;
}

type SearchMotherCompanyNameFieldProps = StateProps & OwnProps;

const searchMotherCompanyNameProps = {
    name: fieldMotherCompanyId,
    label: <LocalizedText textKey={TextKey.MotherCompanyName} />,
    searchType: SearchType.Company,
};

const SearchMotherCompanyNameField = ({
    form,
    preselectedResultId,
    companyId,
    chainId,
}: SearchMotherCompanyNameFieldProps) => (
    <SearchFormField
        {...searchMotherCompanyNameProps}
        scope={form}
        searchScope={`${form}-search-mother-company-name`}
        preselectedResultId={preselectedResultId}
        except={[companyId]}
        optionalSearchParams={{ chainId }}
    />
);

export default connect<StateProps, {}, OwnProps, ApplicationState>((state, { form, companyId }) => ({
    preselectedResultId: formValueSelector(form)(state, fieldMotherCompanyId),
    chainId: getCompanyChainIdIfNoEnterpriseId(state, { id: companyId }),
}))(SearchMotherCompanyNameField);
